import React from "react";
import { Link } from "react-router-dom";
import ContentWrapper from "../ContentWrapper/ContentWrapper";
import fanTokenStyles from "./scss/fan-token.module.scss";

const TopFanTokens = () => {
  const tableHead = [
    "Token Name",
    "Price",
    "Change (24h)",
    "Market Cap",
    "Volume (24h)",
    "volume in token",
    "Circulating Supply",
    "Token Owners",
  ];
  const tableData = [
    {
      image: "/img/token-thumb.png",
      name: "Paris Saint-Germain",
      type: "PSG",
      price: "$14.32",
      change: "1.18%",
      marketCap: "$44,550,080.00",
      volume: "$7,971,415.50",
      tokenVolume: "556,672 PSG",
      supply: "3,111,091",
      owner: "19,696",
    },
    {
      image: "/img/token-thumb.png",
      name: "Paris Saint-Germain",
      type: "PSG",
      price: "$14.32",
      change: "1.18%",
      marketCap: "$44,550,080.00",
      volume: "$7,971,415.50",
      tokenVolume: "556,672 PSG",
      supply: "3,111,091",
      owner: "19,696",
    },
    {
      image: "/img/token-thumb.png",
      name: "Paris Saint-Germain",
      type: "PSG",
      price: "$14.32",
      change: "1.18%",
      marketCap: "$44,550,080.00",
      volume: "$7,971,415.50",
      tokenVolume: "556,672 PSG",
      supply: "3,111,091",
      owner: "19,696",
    },
    {
      image: "/img/token-thumb.png",
      name: "Paris Saint-Germain",
      type: "PSG",
      price: "$14.32",
      change: "1.18%",
      marketCap: "$44,550,080.00",
      volume: "$7,971,415.50",
      tokenVolume: "556,672 PSG",
      supply: "3,111,091",
      owner: "19,696",
    },
    {
      image: "/img/token-thumb.png",
      name: "Paris Saint-Germain",
      type: "PSG",
      price: "$14.32",
      change: "1.18%",
      marketCap: "$44,550,080.00",
      volume: "$7,971,415.50",
      tokenVolume: "556,672 PSG",
      supply: "3,111,091",
      owner: "19,696",
    },
    {
      image: "/img/token-thumb.png",
      name: "Paris Saint-Germain",
      type: "PSG",
      price: "$14.32",
      change: "1.18%",
      marketCap: "$44,550,080.00",
      volume: "$7,971,415.50",
      tokenVolume: "556,672 PSG",
      supply: "3,111,091",
      owner: "19,696",
    },
    {
      image: "/img/token-thumb.png",
      name: "Paris Saint-Germain",
      type: "PSG",
      price: "$14.32",
      change: "1.18%",
      marketCap: "$44,550,080.00",
      volume: "$7,971,415.50",
      tokenVolume: "556,672 PSG",
      supply: "3,111,091",
      owner: "19,696",
    },
  ];

  return (
    <ContentWrapper title={"Top Fan Tokens"}>
      <table className={`${fanTokenStyles.table} w-100`}>
        <thead>
          <tr>
            <th>Token Name</th>
            <th>Price</th>
            <th>Change (24h)</th>
            <th>Market Cap</th>
            <th>Volume (24h)</th>
            <th>volume in token</th>
            <th>Circulating Supply </th>
            <th>Token Owners</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div className={fanTokenStyles.tokenThumb}>
                <img src="/img/token-thumb.png" alt="" />
              </div>
              <label>
                <Link to="/fan-token/paris-saint-germain">
                  Paris Saint-Germain
                </Link>
                <span>PSG</span>
              </label>
            </td>
            <td>$14.32</td>
            <td>1.18%</td>
            <td>$44,550,080.00</td>
            <td className={fanTokenStyles.dataHighlight}>$7,971,415.50</td>
            <td>556,672 PSG</td>
            <td>3,111,091 </td>
            <td>19,696</td>
          </tr>
          <tr>
            <td>
              <div className="token-thumb">
                <img src="img/token-thumb.png" alt="" />
              </div>
              <label>
                <a href="">Manchester City</a>
                <span>CITY</span>
              </label>
            </td>
            <td>$9.32</td>
            <td>2.34%</td>
            <td>$33,820,352.00</td>
            <td className="data-highlight">$2,194,375.75</td>
            <td>227,620 CITY</td>
            <td>3,508,140 </td>
            <td>17,246</td>
          </tr>
          <tr>
            <td>
              <div className="token-thumb">
                <img src="img/token-thumb.png" alt="" />
              </div>
              <label>
                <a href="">FC Barcelona</a>
                <span>BAR</span>
              </label>
            </td>
            <td>$6.34</td>
            <td>7.34%</td>
            <td>$22,406,180.00</td>
            <td className="data-highlight">$3,456,830.75</td>
            <td>833,137 BAR</td>
            <td>3,551,856 </td>
            <td>17,824</td>
          </tr>
          <tr>
            <td>
              <div className="token-thumb">
                <img src="img/token-thumb.png" alt="" />
              </div>
              <label>
                <a href="">AC Milan</a>
                <span>ACH</span>
              </label>
            </td>
            <td>$4.22</td>
            <td>2.45%</td>
            <td>$13,033,269.00</td>
            <td className="data-highlight">$1,585,315.63</td>
            <td>297,879 ACH</td>
            <td>3,141,172</td>
            <td>25,332</td>
          </tr>
          <tr>
            <td>
              <div className="token-thumb">
                <img src="img/token-thumb.png" alt="" />
              </div>
              <label>
                <a href="">Atletico Madrid</a>
                <span>ATM</span>
              </label>
            </td>
            <td>$11.32</td>
            <td>8.41%</td>
            <td>$11,106,930.00</td>
            <td className="data-highlight">$1,102,242.88</td>
            <td>389,322 ATM</td>
            <td>2,086,980</td>
            <td>14,929</td>
          </tr>
          <tr>
            <td>
              <div className="token-thumb">
                <img src="img/token-thumb.png" alt="" />
              </div>
              <label>
                <a href="">Galatasaray</a>
                <span>GAL</span>
              </label>
            </td>
            <td>$1.32</td>
            <td>5.16%</td>
            <td>$9,930,579.00</td>
            <td className="data-highlight">$1,008,131.25</td>
            <td>256,492 GAL</td>
            <td>3,507,572</td>
            <td>13,077</td>
          </tr>
          <tr>
            <td>
              <div className="token-thumb">
                <img src="img/token-thumb.png" alt="" />
              </div>
              <label>
                <a href="">Trabzonspor</a>
                <span>TRA</span>
              </label>
            </td>
            <td>$17.32</td>
            <td>2.34%</td>
            <td>$9,261,275.00</td>
            <td className="data-highlight">$2,194,375.75</td>
            <td>256,492 TRA</td>
            <td>2,356,284</td>
            <td>9,795</td>
          </tr>
          <tr>
            <td>
              <div className="token-thumb">
                <img src="img/token-thumb.png" alt="" />
              </div>
              <label>
                <a href="">Trabzonspor</a>
                <span>TRA</span>
              </label>
            </td>
            <td>$17.32</td>
            <td>2.34%</td>
            <td>$9,261,275.00</td>
            <td className="data-highlight">$2,194,375.75</td>
            <td>256,492 TRA</td>
            <td>2,356,284</td>
            <td>9,795</td>
          </tr>
          <tr>
            <td>
              <div className="token-thumb">
                <img src="img/token-thumb.png" alt="" />
              </div>
              <label>
                <a href="">Trabzonspor</a>
                <span>TRA</span>
              </label>
            </td>
            <td>$17.32</td>
            <td>2.34%</td>
            <td>$9,261,275.00</td>
            <td className="data-highlight">$2,194,375.75</td>
            <td>256,492 TRA</td>
            <td>2,356,284</td>
            <td>9,795</td>
          </tr>
        </tbody>
      </table>
    </ContentWrapper>
  );
};

export default TopFanTokens;
